//操作类型
const opType = new Map([
  [0, '系统登录'],
  [1, '访问页面'],
  [2, '管理操作'],
  [3, '系统安全'],
]);
//审计级别
const audioLevel = new Map([
  [1, '一般'],
  [2, '提示'],
  [3, '警告'],
  [4, '严重'],
]);

function getHeight({
  hasCommand = false,
  line = 1,
  adjust = 0,
} = {}) {


  let top = 60;
  let bottom = 60;
  let lmume = hasCommand ? 46 : 10;
  let searchbox = 46 * line + 48;

  return window.innerHeight - top - bottom - lmume - searchbox - adjust - 80;

  // let lmume = hasCommand ? 46 : 10;
  // let searchbox = 36 * line + 74;

  // return window.innerHeight - top - bottom - lmume - searchbox - adjust - 80;
}

export default {
  opType,
  audioLevel,
  getHeight
}



// WEBPACK FOOTER //
// ./src/js/global_variables.js